import { CommonModule } from '@angular/common';
import {
  Component, forwardRef, Input, OnInit
} from '@angular/core';
import {
  ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { COUNTRIES, Country } from '../utils/nation.utils';


@Component({
  selector: 'country-select',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true
    }
  ],
  templateUrl: './input-country.component.html',
})
export class CountrySelectComponent implements ControlValueAccessor, OnInit {
  @Input() required = false;
  @Input() readonly = false;

  filterControl = new FormControl('');
  control = new FormControl<Country | null>(null);
  COUNTRIES: Country[] = [];

  constructor() {
    this.COUNTRIES = COUNTRIES;

    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  ngOnInit(): void {
    if (this.required) {
      this.control.setValidators(Validators.required);
    }
  }

  onChange = (value: Country | null) => { };
  onTouched = () => { };

  writeValue(value: Country | null): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }
}
